<template>
  <!-- WayForPay placement payments whose email / phone matched no psychologist: the admin credits them -->
  <v-card v-if="payments.length" class="unmatched-payments" outlined>
    <v-card-title class="unmatched-payments__title">{{ t("title") }}</v-card-title>
    <v-card-text>
      <p class="unmatched-payments__hint">{{ t("hint") }}</p>
      <div v-for="payment in payments" :key="payment.id" class="unmatched-payments__row">
        <div class="unmatched-payments__info">
          <b>{{ amountOf(payment) }}</b> · {{ payment.paid_at }}<br />
          {{ payment.email || "—" }} · {{ payment.phone || "—" }}<span v-if="payment.client_name"> · {{ payment.client_name }}</span>
        </div>
        <v-autocomplete
          v-model="chosen[payment.id]"
          :items="psychologists"
          item-text="label"
          item-value="id"
          :label="t('psychologist')"
          class="unmatched-payments__select"
          dense
          outlined
          hide-details
          clearable
        ></v-autocomplete>
        <v-btn
          small
          color="primary"
          :disabled="!chosen[payment.id]"
          :loading="busy === payment.id"
          @click="assign(payment)"
        >{{ t("assign") }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from "vue";
import ApiClient from "@/libs/http-client";

export default {
  name: "UnmatchedPayments",
  data() {
    return {
      payments: [],
      psychologists: [],
      chosen: {},
      busy: null,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    t(key) {
      return this.$vuetify.lang.t(`$vuetify.main.adminDashboard.psychologists.unmatchedPayments.${key}`);
    },
    amountOf(payment) {
      return payment.amount !== null ? `${payment.amount} ${payment.currency || ""}`.trim() : "—";
    },
    load() {
      ApiClient.get("api/admin/psychologists/payments/unmatched").then((response) => {
        this.payments = response.data.data;
        if (this.payments.length && !this.psychologists.length) {
          ApiClient.get("api/admin/blog/posts/authors").then((authors) => {
            this.psychologists = authors.data.data.map((item) => ({
              id: item.id,
              label: item.specialty ? `${item.full_name} — ${item.specialty}` : item.full_name,
            }));
          });
        }
      });
    },
    assign(payment) {
      this.busy = payment.id;
      ApiClient.post(`api/admin/psychologists/payments/unmatched/${payment.id}`, { profile_id: this.chosen[payment.id] })
        .then((response) => {
          Vue.swal({
            target: document.getElementById("main"),
            text: response.data.message,
            icon: "success",
            timer: 5000,
            toast: true,
            position: "top-right",
            showConfirmButton: false,
          });
          this.load();
          this.$emit("assigned");
        })
        .finally(() => {
          this.busy = null;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.unmatched-payments {
  max-width: 900px;
  margin: 0 auto 24px;
  border-color: #e57373 !important;
}
.unmatched-payments__title {
  color: #c62828;
}
.unmatched-payments__hint {
  margin-bottom: 12px;
}
.unmatched-payments__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid #eee;
}
.unmatched-payments__info {
  flex: 1 1 260px;
  min-width: 0;
  overflow-wrap: anywhere;
}
.unmatched-payments__select {
  flex: 1 1 260px;
}
</style>
